import { useState } from "react";
import { supabase } from "./lib/supabase.js";

export function Login() {
  const [mode, setMode] = useState("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    if (mode === "signin") {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    } else {
      const { data, error } = await supabase.auth.signUp({ email, password });
      if (error) {
        setError(error.message);
      } else if (!data.session) {
        setError("Check your email to confirm your account before signing in.");
      }
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    setError(null);
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: window.location.origin },
    });
    if (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setMode(mode === "signin" ? "signup" : "signin");
    setError(null);
  };

  const isSignup = mode === "signup";

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <span style={styles.fox}>🦊</span>
          <span style={styles.name}>Pickfox</span>
        </div>
        <p style={styles.tag}>{isSignup ? "Create your account." : "Sign in to play."}</p>
        <button type="button" onClick={handleGoogle} disabled={loading} style={styles.googleBtn}>
          <GoogleLogo />
          <span>Continue with Google</span>
        </button>
        <div style={styles.divider}>
          <span style={styles.dividerLine} />
          <span style={styles.dividerText}>or</span>
          <span style={styles.dividerLine} />
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Email
            <input type="email" required autoComplete="email" value={email}
              onChange={(e) => setEmail(e.target.value)} style={styles.input}
              placeholder="you@example.com" />
          </label>
          <label style={styles.label}>
            Password
            <input type="password" required
              autoComplete={isSignup ? "new-password" : "current-password"}
              value={password} onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder={isSignup ? "Choose a password (min 6 chars)" : "••••••••"}
              minLength={isSignup ? 6 : undefined} />
          </label>
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? (isSignup ? "Creating account…" : "Signing in…") : isSignup ? "Create account" : "Sign in"}
          </button>
        </form>
        <div style={styles.toggleRow}>
          {isSignup ? "Already have an account?" : "New here?"}{" "}
          <button type="button" onClick={toggleMode} style={styles.toggleBtn}>
            {isSignup ? "Sign in" : "Sign up"}
          </button>
        </div>
      </div>
    </div>
  );
}

function GoogleLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}

const styles = {
  wrap: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f5f1e8", fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif" },
  card: { width: "100%", maxWidth: 380, background: "#fbf8f1", borderRadius: 18, padding: 28, boxShadow: "0 1px 0 rgba(28, 25, 23, 0.04), 0 8px 24px rgba(28, 25, 23, 0.06)", border: "1px solid #ece6d8" },
  brand: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 },
  fox: { fontSize: 28 },
  name: { fontSize: 22, fontWeight: 700, color: "#1c1917", letterSpacing: -0.3 },
  tag: { color: "#78716c", fontSize: 14, margin: "0 0 22px" },
  googleBtn: { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1px solid #d6cfbf", background: "#fff", fontSize: 14, fontWeight: 600, color: "#1c1917", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 },
  divider: { display: "flex", alignItems: "center", gap: 12, margin: "18px 0 14px" },
  dividerLine: { flex: 1, height: 1, background: "#ece6d8" },
  dividerText: { fontSize: 11, color: "#a8a29e", textTransform: "uppercase", letterSpacing: 1.4, fontWeight: 600 },
  form: { display: "flex", flexDirection: "column", gap: 14 },
  label: { display: "flex", flexDirection: "column", gap: 6, fontSize: 12, fontWeight: 600, letterSpacing: 0.6, color: "#57534e", textTransform: "uppercase" },
  input: { padding: "12px 14px", borderRadius: 10, border: "1px solid #d6cfbf", background: "#fff", fontSize: 15, color: "#1c1917", outline: "none", fontFamily: "inherit" },
  error: { background: "#fef2f2", color: "#991b1b", padding: "10px 12px", borderRadius: 8, fontSize: 13, border: "1px solid #fecaca" },
  button: { marginTop: 4, padding: "12px 14px", borderRadius: 10, border: "none", background: "#d97706", color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer" },
  toggleRow: { marginTop: 20, fontSize: 13, color: "#78716c", textAlign: "center" },
  toggleBtn: { background: "transparent", border: "none", padding: 0, color: "#b45309", fontSize: 13, fontWeight: 600, cursor: "pointer", textDecoration: "underline", fontFamily: "inherit" },
};
